/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WeekdayEnum } from './weekdayEnum';
import { ExternalSystemEnum } from './externalSystemEnum';
import { AvailabilityModeEnum } from './availabilityModeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface AvailabilitySchedule { 
    readonly id: number;
    weekday: WeekdayEnum;
    fromTime: string;
    toTime: string;
    startDate?: string | null;
    endDate?: string | null;
    weekInterval?: number;
    availabilityMode: AvailabilityModeEnum;
    externalSystem?: ExternalSystemEnum | null;
    externalSystemAvailabilityId?: string;
}
export namespace AvailabilitySchedule {
}

export const AvailabilitySchedule_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilitySchedule_weekday_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.min(-2.147483648E9), Validators.max(2.147483647E9),];

export const AvailabilitySchedule_fromTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilitySchedule_toTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilitySchedule_startDate_Validators: ValidatorFn[] =
    [ ];

export const AvailabilitySchedule_endDate_Validators: ValidatorFn[] =
    [ ];

export const AvailabilitySchedule_weekInterval_Validators: ValidatorFn[] =
    [  Validators.min(0), Validators.max(32767),];

export const AvailabilitySchedule_availabilityMode_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilitySchedule_externalSystem_Validators: ValidatorFn[] =
    [ ];

export const AvailabilitySchedule_externalSystemAvailabilityId_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];


